// import { UsersService } from '@src/services/users.service'
import GuardianService from './services'
import i18n from '@src/i18n'
import { fullName } from '@src/utils/settings/tenant-user.util.js'
const t = i18n?.global?.t

export default {
  createGuardian({ commit }, payload) {
    return new Promise((resolve, reject) => {
      return GuardianService.createGuardian(payload)
        .then((response) => {
          commit(
            'toast/NEW',
            { message: 'Guardian created successfully', type: 'success' },
            { root: true },
          )
          resolve(response.data)
        })
        .catch((error) => {
          if (error?.message?.includes('email already exists')) {
            error.message = error.message + t(`toast.USE_ADD_EXISTING_USER`)
          }
          commit('toast/NEW', { message: error.message, type: 'error' }, { root: true })
          reject(error)
        })
    })
  },

  getAllGuardians({ commit }, payload) {
    return new Promise((resolve, reject) => {
      return GuardianService.getAllGuardians(payload)
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => {
          commit('toast/NEW', { message: error.message, type: 'error' }, { root: true })
          reject(error)
        })
    })
  },
  getGuardianAssociatedStudents({ commit }, payload) {
    return new Promise((resolve, reject) => {
      return GuardianService.getGuardianAssociatedStudents(payload)
        .then((response) => {
          response.data.records.forEach((record) => {
            record.full_name = `${record.first_name} ${record.last_name}`
          })
          resolve(response)
        })
        .catch((error) => {
          commit('toast/NEW', { message: error.message, type: 'error' }, { root: true })
          reject(error)
        })
    })
  },

  getGuardiansWithFilter({ commit }, payload) {
    return new Promise((resolve, reject) => {
      return GuardianService.getGuardiansWithFilter(payload)
        .then((response) => {
          response?.data?.records.forEach((user) => {
            fullName(user)
          })
          resolve(response.data)
        })
        .catch((error) => {
          commit('toast/NEW', { message: error.message, type: 'error' }, { root: true })
          reject(error)
        })
    })
  },

  getGuardianStats({ commit }, payload = '') {
    return new Promise((resolve, reject) => {
      return GuardianService.getGuardianStats(payload)
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => {
          commit('toast/NEW', { message: error.message, type: 'error' }, { root: true })
          reject(error)
        })
    })
  },

  editGuardian({ commit }, payload) {
    return new Promise((resolve, reject) => {
      return GuardianService.editGuardian(payload)
        .then((response) => {
          commit('toast/NEW', { message: 'Updated Successfully', type: 'success' }, { root: true })
          resolve(response.data)
        })
        .catch((error) => {
          commit('toast/NEW', { message: error.message, type: 'error' }, { root: true })
          reject(error)
        })
    })
  },

  deactivateGuardian({ commit }, payload) {
    return new Promise((resolve, reject) => {
      return GuardianService.deactivateGuardian(payload)
        .then((response) => {
          commit(
            'toast/NEW',
            { message: 'Deactivated Successfully', type: 'success' },
            { root: true },
          )
          resolve(response.data)
        })
        .catch((error) => {
          commit('toast/NEW', { message: error.message, type: 'error' }, { root: true })
          reject(error)
        })
    })
  },
}
